// src/features/help/brandTokens.ts
//
// Pure brand rules behind useHelpTokens. Two different names live here:
//   - brandName: the brand the reader's dashboard wears ({{brandName}} in help
//     articles) — the reseller's label for every reseller-flagged account,
//     the direct brand otherwise;
//   - operatorName: WHO runs the platform for this account (store
//     submissions, delegation, the privacy policy's processor sentence). A
//     reseller ROOT account is our direct customer, so it sees the direct
//     brand; only a reseller's SUB-account (parentCId set) sees the reseller
//     as its operator, never the direct brand.

import { HELP_DIRECT_BRAND_NAME } from './helpConstants';

export interface BrandFacts {
  /** The account carries reseller configuration (its own, or patched in from its parent). */
  isReseller: boolean;
  /** The reseller label the account displays, if any. */
  label?: string | null;
  /** The parent account id when this is a sub-account. */
  parentCId?: number | null;
}

export const RESELLER_FALLBACK_NAME = 'your provider';

export class BrandTokens {
  /** {{brandName}}: the dashboard's brand as this account sees it. */
  static brandName(facts: BrandFacts): string {
    return facts.isReseller ? facts.label || RESELLER_FALLBACK_NAME : HELP_DIRECT_BRAND_NAME;
  }

  /** The platform operator as this account should name it (see the header). */
  static operatorName(facts: BrandFacts): string {
    if (facts.isReseller && facts.parentCId) {
      return facts.label || RESELLER_FALLBACK_NAME;
    }
    return HELP_DIRECT_BRAND_NAME;
  }
}
